"use client";

import dynamic from "next/dynamic";

/**
 * Recharts is ~360 KB and this sparkline sits far below the fold on the
 * homepage, so it must never land in the initial bundle. Loading it client-side
 * only keeps the chart out of the critical path; the skeleton matches the
 * chart's own loading state height so nothing shifts when it arrives.
 */
const AirLiveChartLazy = dynamic(() => import("./AirLiveChart"), {
  ssr: false,
  loading: () => (
    <div className="flex flex-col gap-1.5">
      <div className="h-4 w-32 animate-pulse rounded bg-muted" />
      <div className="h-16 w-full animate-pulse rounded-lg bg-muted" />
    </div>
  ),
});

export default AirLiveChartLazy;
